export default function isDevelopment() {
  return process.env.NODE_ENV === 'development'
}
